import { z } from "zod/v4";

export const RechargeOAuthLoginQueryParamSchema = z.object({
  myshopify_domain: z.string(),
  code: z.string(),
});
export type RechargeOAuthLoginQueryParamType = z.infer<
  typeof RechargeOAuthLoginQueryParamSchema
>;
